import { Outlet, NavLink } from 'react-router-dom'
import { Terminal, Globe, FileText, Key, LogOut } from 'lucide-react'

const navItems = [
  { to: '/', label: 'Dashboard', icon: Terminal },
  { to: '/endpoints', label: 'Endpoints', icon: Globe },
  { to: '/logs', label: 'Logs', icon: FileText },
  { to: '/api-keys', label: 'API Keys', icon: Key },
]

export default function PortalLayout() {
  return (
    <div className="portal-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="logo">IPMOBI</h1>
          <span className="logo-sub">Proxy Portal</span>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'nav-item--active' : ''}`
              }
            >
              <Icon size={20} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="nav-item logout-btn">
            <LogOut size={20} />
            <span>Log Out</span>
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}
